// extracted by mini-css-extract-plugin
module.exports = {"button":"WarrantyInfoLink-Button-module--button--3OJY_"};